module.exports = __webpack_public_path__ + "img/welcome-popup-bg.9d275534.png";